import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Container, Image, HeaderTitle, SubHeaderTitle, ContainerHeader, SubContainerButton, SubContainerField, ContainerImage, ContainerFieldLocation, ContainerContent} from './style'
import InputPassword from '../../components/InputPassword/InputPassword'
import Button from '../../components/Button/Button'
import logo from '../../assets/images/logo.png'
//import disableBrowserBackButton from 'disable-browser-back-navigation'
import ModalAlert from '../../components/ModalAlert/ModalAlert'
import { fetchRegistrarPontoComLoginStart, registrarPontoComLoginReset }  from '../../services/store/reducers/endpoints/registrarPontoComLogin'
import { fetchBaterPontoStart, baterPontoReset }  from '../../services/store/reducers/endpoints/baterPonto'
import CurrentTime from '../../components/CurrentTime/CurrentTime'
import { checkGeolocation, callGeolocation } from '../../helpers/geo'
import { fetchFindCoordsByUnitStart, findCoordsByUnitReset }  from '../../services/store/reducers/endpoints/findCoordsByUnit'
import { fetchRegistrarInfoStart } from '../../services/store/reducers/endpoints/registrarinfo'
import { tokenReset, tokenSave }  from '../../services/store/reducers/token'


class LoginUser extends PureComponent{

  state = {
    senha: '',
    senhaReadOnly: true,
    sended: false,
    sendedBater: false,
    sendedCheckGeo: false,
    toRoute: '',
    disabledConfirmarButton: false,
    confirmarButtonLabel: 'Confirmar',
    executingCheckGeolocation: false,
    executingCallGeolocation: false,
    timeoutExpiredGeo: false
  }

  UNSAFE_componentWillMount () { 

    let toRoute = this.props.location.search
    toRoute = toRoute.split('?to=')[1]
    toRoute = '/' + toRoute.split('&')[0]
    this.setState({toRoute: toRoute})
      

    this.props.tokenReset()
  }

  /*sendCheckGeo = () => {
    this.props.findCoordsByUnitReset()
    this.setState({ sendedCheckGeo: true })
    setTimeout(() => {
      this.props.fetchFindCoordsByUnitStart()
    }, 600)
    
  }*/
  
  confirmar = () => {
    this.setState({disabledConfirmarButton: true})
    this.props.findCoordsByUnitReset()
    console.log('confirmar-->', this.state.senha,this.props.appConfig )
    if (this.state.senha.length < this.props.appConfig.tamanhoMinimoSenha) {
        this.setState({
            titleModal: 'Atenção!',
            messageModal: `A senha deve conter no mínimo ${this.props.appConfig.tamanhoMinimoSenha} caracteres.`,
        });
        return false;
    }
    if (this.state.senha.length > this.props.appConfig.tamanhoMaximoSenha) {
        this.setState({ 
            titleModal: 'Atenção!',
            messageModal: `A senha deve conter no máximo ${this.props.appConfig.tamanhoMaximoSenha} caracteres.`,
        });
        return false;
    }

    

       //internet
       if (!window.navigator.onLine) {
        window.location.href='/report-user?message=-&errorCode=1'
        return
      }
      this.setState({ sendedCheckGeo: true })
      this.props.fetchFindCoordsByUnitStart({unit: this.props.registerPoint.codUnidade})
      
  
  }  

  /*callGeolocationValidationIfNeed = async (nextStepThisFunction) => {
    console.log('this.props.registerPoint--> ', this.props.registerPoint)
    
    if(this.props.appConfig.geoLocalizacao && this.props.registerPoint.coordenadas){
      console.log('chegou aqui')
      this.props.registrarPontoComLoginReset()
      this.setState({ sendedCheckGeo: false })
      let { latitude, longitude } = this.props.sagaFindCoordsByUnit
      
      this.setState({ executingCheckGeolocation: true })
      setTimeout(()=>{
        if(this.state.executingCheckGeolocation){
          this.setState({titleModal: 'Atenção!', messageModal: 'Infelizmente a geolocalização do seu dispositivo falhou e assim não foi possível executar esse comando, por favor, tente novamente.', disabledConfirmarButton: false, confirmarButtonLabel: 'Confirmar', timeoutExpiredGeo: true})    
        }
      }, 10000)
      checkGeolocation().then((result) => {
        this.setState({ executingCheckGeolocation: false })
        
        console.log('heeere', result)
        if(result){
          this.setState({ executingCallGeolocation: true })
          setTimeout(()=>{
            if(this.state.executingCallGeolocation){
              this.setState({titleModal: 'Atenção!', messageModal: 'Infelizmente a geolocalização do seu dispositivo falhou e assim não foi possível executar esse comando, por favor, tente novamente.', disabledConfirmarButton: false, confirmarButtonLabel: 'Confirmar', timeoutExpiredGeo: true})     
            }
          }, 10000)
          callGeolocation(latitude, longitude, (position, distancia) => {
            this.setState({ executingCallGeolocation: false })
            console.log('hereee2 callGeolocation')
            nextStepThisFunction()
          })
        }else{        
          this.props.fetchRegistrarInfoStart({          
            "RE": this.props.registerPoint.re,
            "Empresa": this.props.home.company,
            "Cliente": this.props.registerPoint.codCliente,
            "Unidade": this.props.registerPoint.codUnidade,
            "Detalhes": "Usuário não está com GPS habilitado."
          })
          window.location.href='/report-user?message=Você não esta com gps&errorCode=2'
        }
      })
    }else{
      if(this.props.appConfig.geoLocalizacao && !this.props.registerPoint.coordenadas){
        this.setState({titleModal: 'Atenção!', messageModal: 'As coordenadas referentes a essa unidade (' + this.props.registerPoint.nomeUnidade + ') não foram configuradas! Por favor entre em contato com o supervisor!', disabledConfirmarButton: false, confirmarButtonLabel: 'Confirmar', timeoutExpiredGeo: true})     
      }else{
        nextStepThisFunction()
      }
      
    }
  }*/

  respostaSendCheckGeo = () => {
    this.setState({ sendedCheckGeo: false })
    //this.callGeolocationValidationIfNeed(() => {
      this.props.registrarPontoComLoginReset()
      this.setState({sended: true})
      this.props.fetchRegistrarPontoComLoginStart({
        Empresa: this.props.home.company,
        login: this.props.registerPoint.re, 
        password: this.state.senha 
      })
    //})
    
  }

  isCamposValidos() {
    return !this.state.senha ? false : true
  }
  
  respostaLogin = () => {
    this.setState({sended: false})
    this.props.baterPontoReset()

    let resposta = this.props.sagaRegistrarPontoComLogin
    if(resposta.token) {
      if(this.state.toRoute === '/protocol'){
        window.location.href = '/calendar'
        return
      }
      this.props.tokenSave({ token: resposta.token})
      
      this.setState({sendedBater: true})

      this.props.fetchBaterPontoStart({
        token: this.props.token,
        "Ponto": {
            "RE": this.props.registerPoint.re,
            "Empresa": this.props.home.company,
            "Cliente": this.props.registerPoint.codCliente,
            "Unidade": this.props.registerPoint.codUnidade,
            "HorarioEntrada": this.props.registerPoint.horarioEntrada,
            "HorarioSaida": this.props.registerPoint.horarioSaida,
            "TipoPonto": this.props.pointFlow.tipo
        },
        "Login": {
            "Login": this.props.registerPoint.re,
            "Password": this.state.senha,
            "Empresa": this.props.home.company
        }      
      })
      
    }else{
      this.setState({titleModal: 'Atenção!', messageModal: resposta.message})         
    }
    this.setState({sended: false})
  }

  respostaBaterPonto = () => {
    this.setState({sendedBater: false})
    let resposta = this.props.sagaBaterPonto
    /**
     * validar resposta do bater ponto
     */

     if(!resposta.sucesso){
      this.setState({titleModal: 'Atenção!', messageModal: resposta.mensagem})   
      return
     }

     if(this.props.sagaRegistrarPontoComLogin.trocarSenha) {
        this.setState({titleModal: 'Atenção!',  messageModal: `${resposta.mensagem}.\nVocê ainda está com sua senha inicial, é necessário que a altere.`})   
      }else{
        this.setState({titleModal: 'Atenção!', messageModal: resposta.mensagem})
      }
  }

  voltar = () => {
    console.log('42 voltar aqui', this.props)
    if(this.state.toRoute === '/protocol'){
      window.history.back()
      return
    }
    window.history.back()
    // window.location.href = '/home'
    // window.location.href = '/confirmation-point'
  }

 handleKeyPress = (event) => {
    if(event.key === 'Enter'){
      this.confirmar()
    };
  }

 
  render() {
    const {sagaFindCoordsByUnit, sagaRegistrarPontoComLogin, sagaBaterPonto} = this.props
    const {toRoute, disabledConfirmarButton, confirmarButtonLabel} = this.state

    console.log('dados para acionar o respostaSendCheckGeo', this.state.sendedCheckGeo, sagaFindCoordsByUnit)
    disabledConfirmarButton ?
      this.setState({confirmarButtonLabel: 'Aguarde...'})
    :
      this.setState({confirmarButtonLabel: 'Confirmar'})
    console.log(toRoute)
    return (
      <Container>
        <ContainerImage>
          <Image src={logo} />
        </ContainerImage>
        <CurrentTime></CurrentTime> 
        <ContainerHeader>
          <HeaderTitle>Controle de Ponto</HeaderTitle>
          {
            toRoute === '/protocol' ?
            <SubHeaderTitle>Digite sua senha de acesso para acessar seus protocolos.</SubHeaderTitle>
            :
            <SubHeaderTitle>Digite sua senha de acesso para registro do seu cartão de ponto</SubHeaderTitle>
          }
          
        </ContainerHeader>
        
        <ContainerContent>

          <ContainerFieldLocation>
          <SubContainerField>
            <InputPassword type='text'
            autoComplete={"off"} 
            readOnly={ this.state.senhaReadOnly }
            onFocus={ this.setState({senhaReadOnly: false}) }
            onKeyPress={(event) => { this.handleKeyPress(event)}} 
            onChange={ (event) => { 
              this.setState({senha: event.target.value}) 
            }}
            value={this.state.senha}
            name='oldPassword' placeholder='Senha' />
          </SubContainerField>
          </ContainerFieldLocation>
        </ContainerContent>

        <SubContainerButton>
          <Button width='130px' backgroundColor='#40bbca' onClick={() => { this.voltar() }}>Voltar</Button>
          <Button disabled={this.state.disabledConfirmarButton} width='130px'  backgroundColor='#40bbca' onClick={() => { this.confirmar() }} >{confirmarButtonLabel}</Button>
        </SubContainerButton>

        {
          
          sagaFindCoordsByUnit &&
          this.state.sendedCheckGeo &&
          this.respostaSendCheckGeo()
        }

        {
          sagaRegistrarPontoComLogin &&
          this.state.sended &&
          this.respostaLogin()
        }
        
        {
          sagaBaterPonto &&
          this.state.sendedBater &&
          this.respostaBaterPonto()
        }
        {
          //para colocar os pop up
          this.state.titleModal && 
          this.state.messageModal &&
          this.state.titleModal.length > 0 &&
          this.state.messageModal.length > 0 &&
          <ModalAlert 
            title={this.state.titleModal} 
            message={ this.state.messageModal} 
            onClick={() => {
              
              this.setState({disabledConfirmarButton: false})
              this.setState({messageModal: '', titleModal: ''}) 
              if(this.state.timeoutExpiredGeo){
                this.setState({ timeoutExpiredGeo: false})
                return
              } 
              if(
                sagaBaterPonto 
                && 
                  (
                    (
                      sagaBaterPonto.sucesso
                      && !this.props.sagaRegistrarPontoComLogin.trocarSenha
                    )
                    || (
                      !sagaBaterPonto.sucesso
                      && this.props.sagaRegistrarPontoComLogin.trocarSenha
                    )
                  )
              ) {
                window.location.href = '/home'
                return
              }

              if(
                sagaBaterPonto 
                && sagaBaterPonto.sucesso
                && this.props.sagaRegistrarPontoComLogin.trocarSenha
              ) {
                window.location.href = '/update-password?routeBack=home'
                return
              }
              
              if(
                !this.state.messageModal.includes('Senha incorreta')
                && !this.state.messageModal.includes('Algo deu errado com nossos servidores')
                && !this.state.messageModal.includes('A senha deve conter no')
              ){
                window.location.href = '/home'
                return
              }
            }
            } 
            />
        }    

     </Container>
    )
  } 
}


const mapStateToProps = state => ({
  home: state.home,
  registerPoint: state.registerPoint,
  token: state.token,
  sagaRegistrarPontoComLogin: state.sagaRegistrarPontoComLogin.data,
  sagaBaterPonto: state.sagaBaterPonto.data,
  sagaRegisterPoint: state.sagaRegisterPoint.data,
  sagaFindCoordsByUnit: state.sagaFindCoordsByUnit.data,
  pointFlow: state.pointFlow,
  appConfig: state.appConfig
})

const mapDispatchToProps = dispatch => ({
  fetchFindCoordsByUnitStart: (mss) => dispatch(fetchFindCoordsByUnitStart(mss)),
  findCoordsByUnitReset: () => dispatch(findCoordsByUnitReset()),

  fetchRegistrarPontoComLoginStart: (mss) => dispatch(fetchRegistrarPontoComLoginStart(mss)),
  registrarPontoComLoginReset: () => dispatch(registrarPontoComLoginReset()),

  fetchBaterPontoStart: (mss) => dispatch(fetchBaterPontoStart(mss)),  
  baterPontoReset: () => dispatch(baterPontoReset()),  

  tokenReset: () => dispatch(tokenReset()),
  tokenSave: (value) => dispatch(tokenSave(value)),

  fetchRegistrarInfoStart: (value) => dispatch(fetchRegistrarInfoStart(value))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginUser)